import { deserialize } from '../../../../modules/listing/utils/query-string'
import * as t from '../types'

export default function createFilterValues(props: t.Props) {
  const { categoryPath, filters } = props.context
  const filterValues = deserialize(props.queryString, filters)
  if (props.tag) filterValues.flags = [...filterValues.flags, props.tag]
  if (props.index) filterValues.index = props.index
  filterValues.category = categoryPath
  return filterValues
}
